<template>
  <div class="breadcrumb">
    <el-breadcrumb separator="/">
      <transition-group name="fade-transform" mode="out-in">
        <template v-for="(item, index) in breadList">
          <el-breadcrumb-item :key="index">{{
            item.title === undefined ? 'Dashboard' : item.title
          }}</el-breadcrumb-item>
        </template>
      </transition-group>
    </el-breadcrumb>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    name: 'Breadcrumb',
    data() {
      return {
        activeList: [],
      };
    },
    computed: {
      ...mapState({
        breadList: (state) => state['app'].breadList,
      }),
    },
    mounted() {
      this.getBreadcrumb();
    },
    watch: {
      $route: {
        handler(n) {
          this.getBreadcrumb(n);
        },
        immediate: true,
      },
    },
    methods: {
      //获取面包屑
      getBreadcrumb() {
        this.activeList = [];
        const { fullPath, matched } = this.$route;
        let temp = [];
        matched.forEach((item) => {
          if (item.path === fullPath) {
            this.activeList.push(item.path);
            if (item.parent && item.parent.path && item.parent.path !== '') {
              temp.push({
                title: item.parent.meta.title,
                path: item.parent.path,
                icon: item.parent.meta.icon,
              });
            }
            if (temp.findIndex((i) => i.path === item.path) === -1) {
              temp.push({
                title: item.meta.title,
                path: item.path,
                icon: item.meta.icon,
              });
            }
          }
        });
        this.$store.commit('app/SET_BREAD_LIST', temp);
        //activeList取出vuex面包屑的第一项和最后一项，由于中间无论多少项都是不可点击的，所以拿出来和面包屑导航进行比较
        /*this.activeList = [];
        this.activeList.push(this.$store.state.app.breadList[0]);
        this.$store.commit('app/SET_BREAD_LIST', this.activeList);*/
      },
    },
  };
</script>
<style lang="scss" scoped>
  .breadcrumb {
    margin-left: 10px;
  }
  .el-breadcrumb {
    font-size: 18px;
  }

  .el-breadcrumb__item {
    float: left;
    color: #fff !important;
  }

  ::v-deep .is-link {
    color: #fff !important;
  }

  ::v-deep .el-breadcrumb__inner {
    color: #fff !important;
  }

  .el-breadcrumb__item:last-child .el-breadcrumb__inner,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
    font-weight: 400;
    color: #fff !important;
    cursor: text;
  }
</style>
